import { default_cart_detail } from '@/modules/cart/services';
import { CartDetail } from '@/modules/cart/types';

export default class CartDetailState {
  current_cart: CartDetail = default_cart_detail();
}
